import { queryClient } from "@/network/queryClient";
import { QueryKeys } from "@/network/queryKeys";

export const FreeSlotsCacheService = {
  invalidateAll() {
    return queryClient.invalidateQueries(QueryKeys.freeSlots);
  },
};
